import { useCallback, useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { LuPencilLine } from "react-icons/lu";
import { AiOutlineDelete } from "react-icons/ai";
import { toast } from "react-toastify";
import ConfirmationPage from "../../common/ConfirmationPage";
import { deleteInterface, getInterfaces } from "../../redux/services/interfaceSlice";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../constant";

const Interface = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const getInterfaceData = useSelector((state) => state?.interface?.interfaceData);

  const [page, setPage] = useState(0);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [confirm, setConfirm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchData, setSearchData] = useState("");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);

  const getAllInterfaces = useCallback(async () => {
    try {
      await dispatch(getInterfaces({ page: page + 1, limit: pageLimit, searchData }));
    } catch (error) {}
  }, [dispatch, page, pageLimit, searchData]);

  useEffect(() => {
    getAllInterfaces();
  }, [getAllInterfaces]);

  const deleteInterfaceData = async () => {
    try {
      const response = await dispatch(deleteInterface(itemToDelete));
      toast.success(response?.payload?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setConfirm(false);
      getAllInterfaces();
    } catch (error) {}
  };

  const columns = [
    { header: "S/N", key: "index", render: (_, __, index) => page * pageLimit + index + 1 },
    { header: "Title", key: "title" },
    { header: "Description", key: "description" },
    { header: "Order", key: "order" },
    {
      header: "Image",
      key: "image",
      render: (image) => (
        <img src={image} alt="interface" className="w-20 h-14 object-cover rounded-xl" />
      ),
    },
  ];

  const actions = [
    {
      icon: <LuPencilLine className="w-5 h-5" />,
      onClick: (row) => {
        navigate(`${ROUTES.WEBSITE.INTERFACE_ADD_EDIT}?interfaceId=${row._id}`, {
          state: { row },
        });
      },
    },
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setItemToDelete(row._id);
        setConfirm(true);
      },
    },
  ];

  return (
    <>
      <Table
        title="Interfaces"
        buttonTitle="Add Interface"
        showSearchbar={true}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        setSearchData={setSearchData}
        onAddClick={() => navigate(ROUTES.WEBSITE.INTERFACE_ADD_EDIT)}
        columns={columns}
        data={getInterfaceData?.interface_data || []}
        actions={actions}
        pageCount={getInterfaceData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
      />
      {confirm && (
        <ConfirmationPage
          topicName="Interface"
          confirm={confirm}
          onDelete={deleteInterfaceData}
          onCancel={() => setConfirm(false)}
        />
      )}
    </>
  );
};

export default Interface;
